import bem from 'utils/bem';

export const cardBlock = bem('clip-select-detail-card');
export const previewBlock = bem('clip-select-detail-card-preview');
export const editPanelBlock = bem('clip-select-detail-edit-panel');
